import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { MmrService } from '../../../../../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim } from '../../../../../../../../../../types/mmr-claims.type';

@Component({
  selector: 'app-courier-collection',
  imports: [DotPulseComponent, DatePipe],
  templateUrl: './courier-collection.component.html',
  styleUrl: './courier-collection.component.scss',
})
export class CourierCollectionComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const planDetails = this.mmrService.planClaimsDetails.claims.value();

    const claim = planDetails?.[this.claimType()] as ClaimDetailsPanelViewClaim;

    const serviceProviderName = (claim?.serviceProvider?.name ?? '').toLowerCase();
    const isEsOrJSTElectronics = !['north west appliance repairs ltd'].includes(serviceProviderName);

    const currentStep = claim?.claimTracker.find((step) => step?.currentStep);

    const isProductFromGame = planDetails?.planOverview?.isProductFromGame ?? false;
    const isGadget = planDetails?.planOverview?.isGadget ?? false;
    const isNorthWestAppliance = serviceProviderName === 'north west appliance repairs ltd';

    const appointment = currentStep?.meta?.appointment;

    return {
      panelTitle:
        isEsOrJSTElectronics && !isGadget && !isProductFromGame ? 'Parts or collection' : 'Courier collection',
      isEsOrJSTElectronics,
      isGadget,
      nextSteps: this.getNextSteps(isGadget, serviceProviderName, isProductFromGame),
      isNorthWestAppliance,
      isProductFromGame,
      appointmentDate: appointment?.appointmentMeta?.date,
      confirmationMessage: this.getConfirmationMessage(isGadget, isProductFromGame, isNorthWestAppliance),
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}

  getNextSteps(isGadget: boolean, serviceProvider: string, isProductFromGame = false) {
    if (isProductFromGame) {
      return [
        "On the day, you'll get a text or email with your time slot (or in the DPD app)",
        'The courier will bring the packaging and postage labels',
        "Once your item reaches the repairer, they'll be in touch about what happens next",
      ];
    }

    if (isGadget) {
      return [
        "On the day, you'll get a text or email with your time slot (on in the DPD app)",
        'The courier will bring the packaging and postage labels',
        "When your item reaches the repairer, they'll send you confirmation and updates about the repair",
      ];
    }

    if (serviceProvider === 'north west appliance repairs ltd') {
      return [
        'On the day, you’ll get a text or email with your time slot (or in the DPD app)',
        'The courier will bring the packaging for your item and deliver it to the repairer',
        'When your item reaches the repairer, they’ll send you confirmation and updates about the repair',
      ];
    }

    return [
      'The repairer will call within one working day (if you booked before 3pm).',
      "They'll either give a collection time or send any parts needed.",
      'DPD will keep you updated by text, email or in their app.',
      'The courier will package and collect the item, and the repairer will let you know when they get it.',
    ];
  }

  getConfirmationMessage(
    isGadget: boolean,
    isGameManufacturer: boolean,
    isNorthWestAppliance: boolean
  ): string | undefined {
    // GAME devices are also gadgets, so check GAME first to show the correct copy.
    if (isGameManufacturer) {
      return "You'll receive confirmation in a text, email or DPD app notification.";
    }

    if (isGadget) {
      return "(You'll have received confirmation in a text, email or DPD app notification.)";
    }

    if (isNorthWestAppliance) {
      return "You'll have received your collection date in a text, email or DPD app notification.";
    }

    return undefined;
  }
}
